import { ManageShippingAddressesCTA } from "./ctas";
export var PoBoxIA = function PoBoxIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DO_NOT_USE_PO_BOXES(strictLocalize);
    },
    getDescription: function getDescription() {
      return [SOME_BRANDS_DO_NOT_SHIP_TO_PO_BOXES(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return ManageShippingAddressesCTA(strictLocalize);
};
var DO_NOT_USE_PO_BOXES = function DO_NOT_USE_PO_BOXES(strictLocalize) {
  return strictLocalize({
    id: "OsMwlu",
    defaultMessage: [{
      "type": 0,
      "value": "Nous vous déconseillons d'utiliser une boîte postale"
    }]
  });
};
var SOME_BRANDS_DO_NOT_SHIP_TO_PO_BOXES = function SOME_BRANDS_DO_NOT_SHIP_TO_PO_BOXES(strictLocalize) {
  return strictLocalize({
    id: "ohXlgz",
    defaultMessage: [{
      "type": 0,
      "value": "Étant donné que certaines marques ne livrent pas à des boîtes postales, nous vous déconseillons d'utiliser une boîte postale comme adresse de livraison. Cliquez sur le bouton ci-dessous pour modifier l'adresse de livraison de votre compte."
    }]
  });
};